import type { Action } from "../../actions/types";

export type StoreState = {
  [key: string]: any;
};

export const initialState: StoreState = {};

export function reducer(state: StoreState = initialState, action: Action) {
  switch (action.type) {
    case "SET_WIDGET_CONFIG":
      return action.data.data;
    case "SESSION_DATA_UPDATE": {
      const sessionCustomer = action.data.customer;
      const legacyCustomer = action.data.legacyWidgetCustomerData;
      if (!sessionCustomer && !legacyCustomer) {
        return state;
      }
      return {
        ...state,
        customer: {
          ...state.customer,
          ...(sessionCustomer || {}),
          ...(legacyCustomer || {}),
        },
      };
    }
    default:
      return state;
  }
}
